import { useTranslation } from 'react-i18next'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../../constants/common'
import Button from '../../../Button'
import { ICON_HEIGHT_16 } from '../../../Icon'
import { PageEmptyState } from '../../../PageEmptyState'
import Text from '../../../Text'

function RentalPortalApplicantProfileTabShell({ EntityIcon, action, textKey }) {
  const { t } = useTranslation()

  return (
    <PageEmptyState EntityIcon={EntityIcon}>
      <Text isSecondary>{t(textKey)}</Text>
      {action ? (
        <Button.Outlined
          isGrey
          beforeIconProps={{
            Icon: action.Icon,
            height: ICON_HEIGHT_16,
          }}
          disabled={Boolean(action.tooltipKey)}
          qaName={action.qaName}
          text={t(action.textKey)}
          tooltip={action.tooltipKey ? t(action.tooltipKey) : null}
          tooltipPlacement={FLOATING_ELEMENT_PLACEMENT.top}
        />
      ) : null}
    </PageEmptyState>
  )
}

export default RentalPortalApplicantProfileTabShell
